export const createProjectSubmissionPayload = (
  form,
  files,
  { disclaimer = "", timestamp = Date.now() } = {}
) => {
  const payload = {
    firstName: form.firstName,
    lastName: form.lastName,
    customerEmail: form.email,
    company: form.company,
    projectName: form.projectName,
    city: form.city,
    state: form.state,
    projectType: form.projectType,
    orderNo: form.orderNumber,
    productsUsed: form.productsUsed,
    projectDescription: form.projectDescription,
    projectLink: form.projectLink,
    designer: form.designer,
    photographer: form.photographer,
    disclaimer,
    disclaimerChecked: form.disclaimerAgreement ? "True" : "False",
    submissionId: `AS-${timestamp}`,
  }

  files.slice(0, 5).forEach((file, index) => {
    const attachmentNumber = index + 1
    payload[`fileName${attachmentNumber}`] = file.uploadedFileName ?? file.name
    payload[`attachmentLink${attachmentNumber}`] = file.link
  })

  return payload
}
